import { localStorage } from 'dibs-browser-storage';

import { getFavoritesNudgeDisplayedCount } from './getFavoritesNudgeDisplayedCount';
import { FAVORITES_LOCAL_STORAGE_KEYS } from '../constants';

function updateFavoritesNudgeDisplayedCount(): void {
    const favoritesNudgeDisplayedCount = getFavoritesNudgeDisplayedCount();
    localStorage.setItem(
        FAVORITES_LOCAL_STORAGE_KEYS.FAVORITES_NUDGE_DISPLAYED_COUNT,
        favoritesNudgeDisplayedCount + 1
    );
}

export { updateFavoritesNudgeDisplayedCount };
